module.exports = __webpack_public_path__ + "assets/message-84315917e98a81b123332990702f0133.svg";